import axios from "axios";

const BASE = "https://server.causalfunnels.com/api/geo";

export const geoApi = {
  getProjects: (clientId) => axios.get(`${BASE}/projects`, { params: { clientId } }),
  createProject: (payload) => axios.post(`${BASE}/projects`, payload),
  updateProject: (projectId, data) => axios.patch(`${BASE}/projects/${projectId}`, data),
  deleteProject: (projectId) => axios.delete(`${BASE}/projects/${projectId}`),
  getPrompts: (projectId) => axios.get(`${BASE}/projects/${projectId}/prompts`),
  createPrompt: (projectId, payload) => axios.post(`${BASE}/projects/${projectId}/prompts`, payload),
  bulkCreatePrompts: (projectId, prompts) =>
    axios.post(`${BASE}/projects/${projectId}/prompts/bulk`, { prompts }),
  updatePrompt: (projectId, promptId, payload) =>
    axios.patch(`${BASE}/projects/${projectId}/prompts/${promptId}`, payload),
  triggerRun: (projectId) => axios.post(`${BASE}/projects/${projectId}/runs`),
  getRuns: (projectId) => axios.get(`${BASE}/projects/${projectId}/runs`),
  cancelRun: (runId) => axios.post(`${BASE}/runs/${runId}/cancel`),
  getResults: (runId) => axios.get(`${BASE}/runs/${runId}/results`),
  getAnalytics: (projectId) => axios.get(`${BASE}/projects/${projectId}/analytics`),
  getShareOfVoice: (projectId) => axios.get(`${BASE}/projects/${projectId}/share-of-voice`),
  getCompetitorAnalytics: (projectId) =>
    axios.get(`${BASE}/projects/${projectId}/competitor-analytics`),
  getInsights: (projectId) => axios.get(`${BASE}/projects/${projectId}/insights`),
  markInsightActioned: (insightId, actioned) =>
    axios.patch(`${BASE}/insights/${insightId}`, { actioned }),
  getPromptStatus: (projectId) => axios.get(`${BASE}/projects/${projectId}/prompt-status`),
};
